module.exports = __webpack_public_path__ + "media/images/front/icon_search_01-f4b5444177d498294994e1803ceeaaa0.svg";